<template>
  <div class="app-activation-tariff-heading">
    <div class="tariff-name" :class="'text-'+ tariff.tariffExtra.class">
      <dyn-slot :slot-data="tariff">
        <slot name="txtName">
          <h2>{{ tariff.name }}</h2>
        </slot>
      </dyn-slot>
    </div>
    <div class="tariff-detail">
      <div class="tariff-volumen" v-html="tariff.tariffExtra.volume"></div>
      <div class="tariff-benefit">
        <div class="tariff-flat" v-if="tariff.phoneFlat === 'all' && tariff.smsFlat === 'all'">
          <dyn-slot :slot-data="tariff">
            <slot name="txtFlat">
              <b>Telefon + SMS-Flat</b><sup>{{ tariff.tariffExtra.sup }}</sup>
            </slot>
          </dyn-slot>
        </div>
        <div class="tariff-flat" v-if="tariff.phoneFlat === 'none' && tariff.smsFlat === 'none'" v-html="tariff.tariffExtra.units"></div>
        <div class="tariff-bonus" v-html="tariff.tariffExtra.bonus"></div>
      </div>
      <div class="tariff-duration">
        <div v-if="tariff.basicFee !== 0" class="tariff-price">
          <div><strong :class="'text-'+ tariff.tariffExtra.class">{{ tariff.formattedBasicFee }}</strong>/ {{tariff.runtime.amount}} {{ tariff.formattedUnit }}
            {{ tariff.unit }}<sup>{{ tariff.tariffExtra.sup }}</sup></div>
        </div>
        <div class="tariff-termination">
          <span v-html="tariff.tariffExtra.termination"></span>
          <span><sup>{{ tariff.tariffExtra.sup }}</sup></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'TariffHeading',
  mixins: [
    slotProxy()
  ],
  props: {
    tariff: {
      type: Object,
      default: null
    }
  }
}
</script>
